<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a" id="heading_id_2">CONTENTS</h2>
<p class="toc"><span><a id="ich01"></a><a href="#/Text/chapter01#ch01">Chapter 1</a></span></p>
<p class="toca"><span><a href="#/Text/chapter01#ch01">Crouching at the Door</a></span></p>
<p class="toc"><span><a id="ich02"></a><span href="#/Text/chapter02#ch02" title="Link target outside of Sample">Chapter 2</span></span></p>
<p class="toca"><span><span href="#/Text/chapter02#ch02" title="Link target outside of Sample">Alive for the First Time</span></span></p>
<p class="toc"><span><a id="ich03"></a><span href="#/Text/chapter03#ch03" title="Link target outside of Sample">Chapter 3</span></span></p>
<p class="toca"><span><span href="#/Text/chapter03#ch03" title="Link target outside of Sample">Rage</span></span></p>
<p class="toc"><span><a id="ich04"></a><span href="#/Text/chapter04#ch04" title="Link target outside of Sample">Chapter 4</span></span></p>
<p class="toca"><span><span href="#/Text/chapter04#ch04" title="Link target outside of Sample">Lust and Adultery</span></span></p>
<p class="toc"><span><a id="ich05"></a><span href="#/Text/chapter05#ch05" title="Link target outside of Sample">Chapter 5</span></span></p>
<p class="toca"><span><span href="#/Text/chapter05#ch05" title="Link target outside of Sample">Lying and Stealing</span></span></p>
<p class="toc"><span><a id="ich06"></a><span href="#/Text/chapter06#ch06" title="Link target outside of Sample">Chapter 6</span></span></p>
<p class="toca"><span><span href="#/Text/chapter06#ch06" title="Link target outside of Sample">Addiction</span></span></p>
<p class="toc"><span><a id="ich07"></a><span href="#/Text/chapter07#ch07" title="Link target outside of Sample">Chapter 7</span></span></p>
<p class="toca"><span><span href="#/Text/chapter07#ch07" title="Link target outside of Sample">Homosexuality</span></span></p>
<p class="toc"><span><a id="ich08"></a><span href="#/Text/chapter08#ch08" title="Link target outside of Sample">Chapter 8</span></span></p>
<p class="toca"><span><span href="#/Text/chapter08#ch08" title="Link target outside of Sample">Broken Lives</span></span></p>
<p class="toc"><span><a id="ich09"></a><span href="#/Text/chapter09#ch09" title="Link target outside of Sample">Chapter 9</span></span></p>
<p class="toca"><span><span href="#/Text/chapter09#ch09" title="Link target outside of Sample">Biology Is Not Destiny</span></span></p>
<p class="toc"><span><a id="iapp01"></a><span href="#/Text/appendix#app01" title="Link target outside of Sample">Appendix</span></span></p>
<p class="toca"><span><span href="#/Text/appendix#app01" title="Link target outside of Sample">Counseling and Ministry Resources</span></span></p>
<p class="toc"><span><a id="inotes"></a><span href="#/Text/notes#notes" title="Link target outside of Sample">Notes</span></span></p>
<p class="tocb"><span><a id="author"></a><span href="#/Text/abouttheauthor#author" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?74014140